import { SendAnswerEvent } from "@domain";
import { BasePeerCommand } from "./BasePeerCommand";

export class SendAnswerCommand extends BasePeerCommand {
  public execute(event: CustomEvent<SendAnswerEvent>): void {
    const room = this.getRoom();
    this.signalingService.sendAnswer(
      room.id,
      event.detail.description,
      this.getRoomLocalParticipantRemoteId(),
      event.detail.to
    );
  }
}
